import ConstructionLobbyPage from './construction-lobby-page';
export default ConstructionLobbyPage;